export default "__VITE_ASSET__85675b6b__"